import { http } from './http';
import { ComplianceOverview } from '../lib/compliance';

/** 의무 일정 · 투자 의무 비율 — /api/compliance (서버가 규칙대로 계산한다) */
export const complianceApi = {
  overview: () => http.get<ComplianceOverview>('/compliance/overview'),
};
